// Custom event for order updates
export function notifyOrderStatusUpdated() {
  const event = new CustomEvent('orderStatusUpdated');
  window.dispatchEvent(event);
}

// Check if the current route is the staff order page
export function isStaffOrderPage() {
  return window.location.pathname.includes('/orders');
}
